export default __webpack_public_path__ + "static/media/shape.5c7650de.png";